// extracted by mini-css-extract-plugin
export default {"Heading":"ErrorPage-module__Heading--UGKqI","Status":"ErrorPage-module__Status--fcyMK","Message":"ErrorPage-module__Message--Bkeiv"};